import { useContext, useEffect } from 'react';
import InfoBox from '../../atoms/InfoBox/InfoBox';
import LinkBox from '../../atoms/LinkBox/LinkBox';
import GlobalVariablesContext from '../../contexts/GlobalVariablesContext';

const LogoutPage = () => {

    const { giftsApi, setAccount } = useContext(GlobalVariablesContext);

    useEffect(() => {
        giftsApi.logout();
        setAccount(null);
    }, [giftsApi]);

    return (
        <>
            <h2>Logged Out</h2>
            <InfoBox message='You are now logged out.' />
            <LinkBox href="/login" label="Back to home page" />
        </>
    );
}

export default LogoutPage;